// extracted by mini-css-extract-plugin
module.exports = {"LanguageContainer":"LanguageModal_LanguageContainer__sXKUK","LanguageItem":"LanguageModal_LanguageItem__2Iaqx","Selected":"LanguageModal_Selected__1Tlgi"};